// Combo's table inputs. The table renders the drill-down level, so it carries its own answer
// and variants rather than the charts model's; everything the sentiments table has no branch
// for -- traits, thumbnails -- is resolved by the shell and passed through.

import { ROOT_SCOPE, resolveAnswer, resolveAnswerVariants } from '@aytm/app/stats/page/question-views/cx/lib/scope'
import { calcTableProps as calcOeTableProps } from '@aytm/app/stats/page/question-views/oe/lib/props/table'

// The nested charts draw the whole tree and name a node by its path from the root, while the rows
// are the drilled level alone -- so a row can only find its node once it carries that path. Null
// under the plain chart, whose points are named after the answer and are found by position.
const TREE_VIEW_MODES = ['sunburst', 'treemap']

export const calcRowPointPath = ({ viewMode, scope }) =>
  TREE_VIEW_MODES.includes(viewMode) ? (scope || []).filter(level => ROOT_SCOPE !== level) : null

export const calcScopedAnswerVariants = ({ scope, answerVariants }) =>
  (resolveAnswerVariants(scope, answerVariants) || []).filter(av => av)

export const calcTableProps = inputs => {
  const { scope, answer, answerVariants, answerType, type, format, rType, trait, traitName, isTraitType } = inputs
  const { handlers = {} } = inputs

  return {
    ...calcOeTableProps(inputs),
    answer: resolveAnswer(scope, answer),
    pointPath: calcRowPointPath(inputs),
    answerVariants: calcScopedAnswerVariants({ scope, answerVariants }),
    answerType: answerType || 'amount',
    type,
    format,
    rType: rType || 'cases',
    trait,
    traitName,
    isTraitType,
    // cx rows are the drill-down level, so a label descends instead of applying a filter; scx
    // rows are a real question's variants and keep the family's filter behaviour
    ...('cx' === type ? { onLabelClick: handlers.onScopeLabelClick } : {})
  }
}
